{
  "signInRecovery": {
    "title": "Inloggningen avbröts",
    "processing": "Slutför inloggningen…",
    "message": "Inloggningen kunde inte slutföras. Logga in igen för att fortsätta.",
    "action": "Logga in igen",
    "starting": "Startar inloggningen…",
    "restartFailed": "Inloggningen kunde inte startas. Kontrollera att webbläsaren tillåter lagring av webbplatsdata och försök igen."
  },
  "loading": "Laddar...",
  "save": "Spara",
  "cancel": "Avbryt",
  "delete": "Radera",
  "search": "Sök",
  "close": "Stäng",
  "confirm": "Bekräfta",
  "yes": "Ja",
  "no": "Nej",
  "error": "Fel",
  "success": "Lyckades",
  "retry": "Försök igen",
  "upload": "Ladda upp",
  "download": "Ladda ner",
  "logout": "Logga ut",
  "back": "Tillbaka",
  "redirectingToLogin": "Omdirigerar till inloggning...",
  "profile": "Profil",
  "settings": "Inställningar",
  "user": "Användare",
  "unnamedPerson": "Namnet har inte registrerats",
  "language": "Språk",
  "selectLanguage": "Välj ditt språk",
  "appSwitcher": {
    "selectApp": "Välj app",
    "title": "Appar",
    "description": "Växla mellan Agion-appar",
    "tooltip": "Byt app",
    "admin": "Admin",
    "control": "Control",
    "app": "App",
    "analytics": "Analytics"
  },
  "adminDashboard": "Adminpanel",
  "profileSettings": "Profil & Inställningar",
  "uploadFiles": "Ladda upp filer",
  "uploadingFiles": "Laddar upp filer...",
  "pleaseWait": "Vänta",
  "dropFilesHere": "Släpp filer här",
  "dropFilesOrClick": "Släpp filer eller klicka",
  "fileTypes": "Excel, CSV, JSON upp till {{size}}MB",
  "status": {
    "active": "Aktiv",
    "busy": "Upptagen",
    "offline": "Offline",
    "pending": "Väntande",
    "uploading": "Laddar upp",
    "processing": "Bearbetar",
    "completed": "Slutförd",
    "error": "Fel",
    "uploaded": "Uppladdad",
    "processed": "Bearbetad"
  },
  "roles": {
    "owner": "Ägare",
    "admin": "Administratör",
    "manager": "Chef",
    "user": "Användare",
    "auditor": "Revisor"
  },
  "you": "Du",
  "agent": "Agent",
  "manager": "Chef",
  "agents": {
    "system": {
      "assistant": "Agion Assistent"
    }
  },
  "hitl": {
    "expired": "Den här förfrågan har gått ut.",
    "timeout": "Går ut om {{time}}",
    "placeholder": "Skriv ditt svar...",
    "governanceRule": "Styrningsregel: {{rule}}",
    "operatorHandoff": {
      "title": "Agenten behöver operatörshjälp",
      "description": "Agenten kan inte lösa detta och begär mänsklig assistans"
    },
    "policyReview": {
      "title": "Styrningsgranskning krävs",
      "description": "En styrningspolicy kräver mänsklig granskning innan fortsättning",
      "approve": "Godkänn",
      "deny": "Neka",
      "decideElsewhere": "Det här godkännandet avgörs i Eskaleringar.",
      "openEscalations": "Avgör i Eskaleringar"
    }
  },
  "nextShell": {
    "sidebar": "Chattnavigering",
    "missionsNavigation": "Uppdrag",
    "expandSidebar": "Expandera sidofältet",
    "collapseSidebar": "Fäll ihop sidofältet",
    "resizeSidebar": "Ändra sidofältets bredd",
    "openNavigation": "Öppna navigeringen",
    "closeNavigation": "Stäng navigeringen",
    "organization": "Organisation",
    "files": "Filer",
    "running": "Körs",
    "theme": {
      "currentLight": "Ljust läge",
      "currentDark": "Mörkt läge",
      "switchToLight": "Byt till ljust läge",
      "switchToDark": "Byt till mörkt läge"
    },
    "appSwitcher": {
      "chat": "Chatt",
      "switchApp": "Byt app",
      "currentApp": "Aktuell app",
      "open": "Öppna"
    },
    "missionsLoadError": "Uppdragen kunde inte läsas in"
  },
  "nextFailure": {
    "hostUnknown": "Edge-värden som körde det här uppdraget har inte registrerats, så dess konversation kan inte hittas.",
    "network": "Anslutningen till Agion misslyckades. Kontrollera nätverket och försök igen.",
    "unavailable": "Tjänsten svarar inte just nu. Försök igen om en stund.",
    "session": "Din session har upphört. Logga in igen för att fortsätta.",
    "forbidden": "Din roll tillåter inte detta.",
    "missing": "Det finns inte längre eller har flyttats.",
    "refused": "Begäran avvisades.",
    "unknown": "Något gick fel. Försök igen.",
    "hostOfflineNamed": "{{name}}, Edge-värden som har den här konversationen, är offline. Försök igen när den är tillbaka.",
    "hostOffline": "Edge-värden som har den här konversationen är offline. Försök igen när den är tillbaka."
  }
}
